const n = "_fieldContainer_y4nk1_1", t = "_disabled_y4nk1_10", e = "_textField_y4nk1_14", _ = "_textFilled_y4nk1_17", i = "_compact_y4nk1_26", l = "_leadingIcon_y4nk1_29", a = "_readOnly_y4nk1_32", o = "_prefix_y4nk1_41", c = "_suffix_y4nk1_44", r = "_trailingButtonReadOnly_y4nk1_47", d = "_trailingIcon_y4nk1_62", s = "_regular_y4nk1_66", y = {
  fieldContainer: n,
  "container-regular": "_container-regular_y4nk1_4",
  "container-compact": "_container-compact_y4nk1_7",
  disabled: t,
  textField: e,
  textFilled: _,
  compact: i,
  leadingIcon: l,
  readOnly: a,
  prefix: o,
  suffix: c,
  trailingButtonReadOnly: r,
  trailingIcon: d,
  regular: s
};
export {
  i as compact,
  y as default,
  t as disabled,
  n as fieldContainer,
  l as leadingIcon,
  o as prefix,
  a as readOnly,
  s as regular,
  c as suffix,
  e as textField,
  _ as textFilled,
  r as trailingButtonReadOnly,
  d as trailingIcon
};
//# sourceMappingURL=TextField.module.scss.js.map
